module.exports = __webpack_public_path__ + "media/images/nowprinting-923407422b74289c392c626df22ac2cf.png";